const urls = {
    whatsappApi: {
        LOCAL: "http://localhost:3000",
        DEV: "https://ok1qlahe4k.execute-api.ap-south-1.amazonaws.com",
        PROD: "https://4w1405ijrl.execute-api.ap-south-1.amazonaws.com",
    },
};

export default urls;
